export default [
  // {
  //   header: 'Dashboards',
  //   icon: 'HomeIcon',
  //   children: [
  //     {
  //       title: 'baseTable',
  //       route: 'base-table',
  //       icon: 'ShoppingCartIcon',
  //     },
  //     {
  //       title: 'baseForm',
  //       route: 'base-form',
  //       icon: 'ActivityIcon',
  //     },
  //   ],
  // },
]
